import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UsersTrackingService } from 'src/app/services/users-tracking/users-tracking.service';

@Component({
  selector: 'app-tracking-preparers',
  templateUrl: './tracking-preparers.component.html',
  styleUrls: ['./tracking-preparers.component.css']
})
export class TrackingPreparersComponent implements OnInit {

  preparersList: Observable<Array<any>>;

  constructor(private trackingServices: UsersTrackingService) { }

  ngOnInit(): void {
    this.listPreparers()
  }

  async listPreparers() {
    await this.trackingServices.getPreparers().then((res: any) => {
      if (res) {
        // console.log("leader res");
        // console.log(res);
        this.preparersList = res;
      }
     
    });
  }

}
